import Collapse from './collapse';
import CollapsePanel from './collapse-panel';
var DefaultCollapse = Collapse;
DefaultCollapse.Panel = CollapsePanel;
export default DefaultCollapse;
//# sourceMappingURL=index.js.map